import classNames from 'classnames'
import React from 'react'
import Text from '@/stories/components/Common/NewText'
import InStockL2Heading from '../../Pages/InStockDetailPageV2/InL2Heading'
import Link from '@/components/Common/Link'

const TwoColGrid = ({
  heading,
  subheading = '',
  keyValueData,
}: {
  heading?: string
  subheading?: string
  keyValueData?: {
    key?: string
    value?: string | number
    link?: string
    relative_path?: string
  }[]
}) => {
  return (
    <div className="flex w-full flex-col">
      {heading && (
        <InStockL2Heading heading={heading} subheading={subheading} />
      )}
      <div className="relative mb-6 grid w-full grid-cols-1 gap-y-4 md:grid-cols-2">
        {/* Add vertical divider */}
        <div className="absolute left-1/2 hidden h-full w-[1px] -translate-x-1/2 bg-gray-200 md:block" />

        {!!keyValueData?.length &&
          keyValueData
            .filter(({ key, value }) => key && (value === 0 || value))
            .map(({ key, value, link, relative_path }, index) => (
              <div
                className={classNames('flex flex-row justify-between gap-8', {
                  'md:mr-16': index % 2 === 0,
                  'md:ml-16': index % 2 === 1,
                })}
                key={index}
              >
                {key && (
                  <Text appearance="body1" addClassName="text-brand-grey-dark">
                    {key}
                  </Text>
                )}
                {value && (
                  <div className="flex flex-col items-end gap-1">
                    <Text
                      appearance="subtitle1"
                      addClassName="text-brand-black"
                    >
                      {value}
                    </Text>

                    {link && relative_path && (
                      <Link href={relative_path}>
                        <Text
                          appearance="caption"
                          addClassName="text-brand-blue-azureRadiance"
                        >
                          {link}
                        </Text>
                      </Link>
                    )}
                  </div>
                )}
              </div>
            ))}
      </div>
    </div>
  )
}

export default TwoColGrid
